import { render, staticRenderFns } from "./HotlinkMedicine.vue?vue&type=template&id=3c18117a&"
import script from "./HotlinkMedicine.vue?vue&type=script&lang=js&"
export * from "./HotlinkMedicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports